import {
  BUSS_PART_FILTER_OPTIONS,
  getbussinesParticularities,
} from '@shared-logic/business-particularities';
import { Price } from '@shared-logic/prices';

const businessParticularitiesByPriceCache = new WeakMap<object, string[]>();

type BusinessParticularitiesFilterShape = {
  businessParticularities?: string[];
  particularity?: string[];
};

export const BUSINESS_PARTICULARITIES_FILTER_OPTIONS: string[] = BUSS_PART_FILTER_OPTIONS;

function normalizeBusinessParticularitiesSelection(
  ...selections: Array<string[] | null | undefined>
): string[] {
  const normalizedSelection: string[] = [];
  const seen = new Set<string>();

  for (const selection of selections) {
    if (!Array.isArray(selection)) {
      continue;
    }

    for (const value of selection) {
      if (typeof value !== 'string' || value.length === 0 || seen.has(value)) {
        continue;
      }

      seen.add(value);
      normalizedSelection.push(value);
    }
  }

  return normalizedSelection;
}

export function getSelectedBusinessParticularitiesFromFilter(
  filter: BusinessParticularitiesFilterShape | null | undefined
): string[] {
  if (!filter) {
    return [];
  }

  return normalizeBusinessParticularitiesSelection(
    filter.businessParticularities,
    filter.particularity
  );
}

export function setSelectedBusinessParticularitiesInFilter<
  T extends BusinessParticularitiesFilterShape
>(filter: T, selected: string[]): T {
  const normalizedSelection = normalizeBusinessParticularitiesSelection(selected);

  filter.businessParticularities = [...normalizedSelection];
  filter.particularity = [...normalizedSelection];

  return filter;
}

export function getBusinessParticularitiesFromPriceCached(price: Price | undefined): string[] {
  if (!price || typeof price !== 'object') {
    return [];
  }

  const cached = businessParticularitiesByPriceCache.get(price as object);
  if (cached) {
    return cached;
  }

  const computed = getbussinesParticularities(price.businessParticularities, price);
  businessParticularitiesByPriceCache.set(price as object, computed);
  return computed;
}

export function matchesBusinessParticularitySelection(
  price: Price | undefined,
  selectedSet: ReadonlySet<string>
): boolean {
  if (selectedSet.size === 0) {
    return true;
  }

  const businessParticularities = getBusinessParticularitiesFromPriceCached(price);
  for (const businessParticularity of businessParticularities) {
    if (selectedSet.has(businessParticularity)) {
      return true;
    }
  }

  return false;
}